import { motion } from "framer-motion";
import { revealUp, staggerParent, viewportOnce } from "../../lib/motion";

export const Equation = () => {
  return (
    <section data-testid="story-equation" className="py-4 sm:py-6">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          variants={staggerParent}
          className="w-full rounded-[28px] bg-paper px-6 py-16 sm:px-14 sm:py-24 lg:py-28"
        >
          <motion.p variants={revealUp} className="mb-5 text-center font-mono text-xs uppercase tracking-[0.3em] text-labred">
            04 / THE EQUATION
          </motion.p>
          <motion.h2
            variants={revealUp}
            className="mx-auto max-w-4xl text-center font-display text-4xl leading-[1.05] tracking-tight text-inkred sm:text-6xl"
          >
            WE TURNED FLAVOR INTO A <span className="text-labred">FORMULA.</span>
          </motion.h2>

          <motion.p
            variants={revealUp}
            className="mx-auto mt-12 max-w-[820px] text-center font-display text-2xl italic leading-snug text-inkred/90 sm:text-3xl"
          >
            &ldquo;We are redefining the art of chicken through absolute discipline.&rdquo;
          </motion.p>

          <motion.div variants={revealUp} className="mx-auto mt-12 grid max-w-[900px] grid-cols-1 gap-8 md:grid-cols-2">
            <p className="font-body text-base leading-relaxed text-inkred/75">
              In the world of Chicken Labb, every plate is a work of art and every recipe is an
              engineering achievement. We select the finest ingredients and combine them in exact
              balance, with precision measured to the gram.
            </p>
            <p className="font-body text-base leading-relaxed text-inkred/75">
              The golden rise inside our flask is the signature crunch of our chicken and the
              mystery of our secret sauces. This is not ordinary fast food. This is a futuristic
              gastronomic experience with premium precision hidden in every detail.
            </p>
          </motion.div>

          <motion.p
            variants={revealUp}
            className="mx-auto mt-14 max-w-[760px] text-center font-display text-xl leading-tight tracking-tight text-labred sm:text-3xl"
          >
            WE TURNED FLAVOR INTO AN EQUATION. ALL THAT&apos;S LEFT FOR YOU IS TO TASTE IT.
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
};
